
/* injects from baggage-loader */

export const balloonsDone = {
	route:'main.stage-fifth',
	dialog: ["Muito bem! <br>Você completou corretamente essas <br>páginas. Mas parece que você já <br>conquistou a premiação deste <br>nível.",
    "Você também pode repetir a <br>atividade que acabou de fazer,<br> escolhendo outra categoria."],
    confirmation:true
}

export const balloonsFirst = {
	route:'main.stage-fifth',
	dialog: ["Você completou as páginas do <br>álbum e por isso ganhou mais uma <br>peça para o seu quebra-cabeça. <br>Agora só faltam mais 3(três)!",
    "Continue completando as próximas <br>páginas do álbum para ganhar <br>todas as peças do seu  <br>quebra-cabeça!",
    "Você também pode repetir a <br>atividade que acabou de fazer,<br> escolhendo outra categoria."],
    confirmation:true
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-fifth/stage-fifth.const.js